import React, { useCallback, useRef, useState } from 'react';

/**
 * One polite live region for Ask ResAI status changes (pins, progress, stop). Returns
 * [announce(text), regionElement]. Re-announcing the same text still speaks, because the
 * region is cleared first. Messages announced together (within 50 ms, such as a question and
 * its answer arriving in one update) are spoken together, in order, rather than the last
 * replacing the others.
 */
export default function useAnnouncer() {
  const [message, setMessage] = useState('');
  const timer = useRef(null);
  const pending = useRef([]);
  const announce = useCallback((text) => {
    clearTimeout(timer.current);
    if (!pending.current.includes(text)) pending.current.push(text);
    setMessage('');
    timer.current = setTimeout(() => {
      setMessage(pending.current.map((t) => (/[.!?]$/.test(t) ? t : `${t}.`)).join(' '));
      pending.current = [];
    }, 50);
  }, []);
  const region = (
    <div className="iter1-sr-only" role="status" aria-live="polite" aria-atomic="true">
      {message}
    </div>
  );
  return [announce, region];
}
